import { Component, inject, computed, input, output } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { ThemeService, ThemeOption } from '../core/services/theme.service';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class Header {
  private auth = inject(AuthService);
  private themeService = inject(ThemeService);

  readonly quickStartOpen = input(false);
  /** True while the guide has pending tasks — drives the rocket notification dot. */
  readonly quickStartPending = input(false);
  readonly sidebarCollapsed = input(false);
  readonly toggleQuickStart = output<void>();
  readonly toggleSidebar = output<void>();

  readonly activeTheme = this.themeService.activeTheme;

  readonly availableThemes = computed(() => {
    const current = this.activeTheme();
    return this.themeService.themes.filter(t => t.id !== current.id);
  });

  get username(): string {
    const user = this.auth.session()?.user;
    if (!user) return 'Guest';
    return user.displayName?.trim() || user.username;
  }

  changeTheme(theme: ThemeOption): void {
    this.themeService.setTheme(theme);
  }

  openEditAccount(): void {
    this.auth.editAccountOpen.set(true);
  }

  onToggleQuickStart(): void {
    this.toggleQuickStart.emit();
  }

  onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }
}
